/** Path of the former API Explorer, now a redirect (AD-2). */
export const API_DOCS_PATH = '/api-docs';

/** Catálogo on the APIs tab: where "APIs" leads from the menu and the home. */
export const APIS_CATALOG_PATH = '/catalog?filters[kind]=api';

/** True when the location is the Catálogo index filtered to `kind=api`. */
export function isCatalogApis(location: {
  pathname: string;
  search: string;
}): boolean {
  if (location.pathname.replace(/\/$/, '') !== '/catalog') {
    return false;
  }
  const kind = new URLSearchParams(location.search).get('filters[kind]');
  return kind?.toLocaleLowerCase('en-US') === 'api';
}
